// RequireToolAccess — route-level guard for client-only tools that have no
// API surface protected by requireToolAccess. Mirrors the Sidebar/Dashboard
// visibility rule (admin bypass, otherwise a tool_permissions grant) so a
// deep link cannot bypass the per-tool permission configured in the admin UI.
import type { ReactNode } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "../auth/useAuth";

export function RequireToolAccess({
  toolId,
  children,
}: {
  toolId: string;
  children: ReactNode;
}) {
  const { user, loading, isAdmin } = useAuth();

  if (loading) return null;

  const granted = isAdmin || (user?.toolPermissions ?? []).includes(toolId);
  if (granted) return <>{children}</>;

  return (
    <div style={{ maxWidth: 560 }}>
      <div className="bsp-page-header">
        <div className="bsp-page-icon">
          <Lock size={18} />
        </div>
        <h1 className="bsp-page-title">Access required</h1>
      </div>
      <div className="bsp-card">
        <p style={{ margin: 0, fontSize: 13, color: "var(--bsp-fg-muted)", lineHeight: 1.5 }}>
          You don’t have access to this tool yet. Ask an administrator to
          grant it from the User Management page.
        </p>
      </div>
    </div>
  );
}
